import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlightSearch'
})
export class HighlightSearchPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string, args: string): SafeHtml {
    if (!args) { return value; }
    // Escape special regex characters to avoid errors in the regex
    const escapedArgs = args.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const re = new RegExp(escapedArgs, 'gi');
    const match = value.match(re);

    if (!match) {
      return value;
    }

    const replacedValue = value.replace(re, `<span class="highlight">${match[0]}</span>`);
    return this.sanitizer.bypassSecurityTrustHtml(replacedValue);
  }
}
